// MF entry exposed as ./AppMount; loads runtime settings, registers remotes, then wraps the bootloader.
import { loadAppSettings } from './appSettings';
import { registerRuntimeRemotes } from './designSystemRemote';

const REQUIRED_SETTINGS = [
  'SHIPBOB_DESIGN_SYSTEM',
  'SHIPBOB_MFE_RUNTIME',
  'AUTHENTICATION_AUTHORITY',
  'CLIENT_ID',
  'CLIENT_SCOPE',
  'RECEIVING_OPS_URL',
  'INVENTORY_MANAGEMENT_API_URL',
  'MFE_ROOT_ROUTE',
];

/** Load settings, validate required keys (throws listing any missing), then register the runtime
 *  remotes (throws if a required remote URL is rejected — failing loud here beats a cryptic MF
 *  resolution error later). */
export async function prepareRuntime(action) {
  const appSettings = await loadAppSettings();

  const missing = REQUIRED_SETTINGS.filter(
    (key) => typeof appSettings[key] !== 'string' || !appSettings[key].trim(),
  );
  if (missing.length) {
    throw new Error(`[receiving-ui] cannot ${action}: missing required app settings: ${missing.join(', ')}`);
  }

  if (!registerRuntimeRemotes(appSettings)) {
    throw new Error(
      `[receiving-ui] cannot ${action}: a required runtime remote URL is not an absolute http(s) URL`,
    );
  }
}

/** Mount into a host-provided element; returns the bootloader's unmount fn. */
export const mount = async (args = {}) => {
  await prepareRuntime('mount');
  const { mount: appMount } = await import('./bootloader');
  return appMount(args);
};
